import { ApiLayer } from '@/api/utils/api-layer';
import { axiosApp, AxiosClient } from '@/api/utils/client/axios';
import { LegacySchema } from '@/types/legacy-schema';
import { mapItemWithSchema } from './map-schema-fields';

type VacancyRequestLegacySchema = {
  account: number;
  active: boolean;
  attendee_hint: string;
  attendee_required: boolean | null;
  id: number;
  name: string;
  restricted_for: string[];
  schema: LegacySchema;
};

type VacancyRequestTemplateList = {
  items: VacancyRequestLegacySchema[];
};

interface VacancyRequestParams {
  only_active?: boolean;
}

class VacancyRequestLegacySchemaLayer extends ApiLayer<AxiosClient> {
  constructor(client: AxiosClient) {
    super(client);

    this.getById = this.memoizeMethod(this.getById);
    this.getList = this.memoizeMethod(this.getList);
  }

  getList(params: VacancyRequestParams = {}) {
    return this.methods
      .get<VacancyRequestTemplateList>('/account/vacancy_request', { params })
      .then(({ items }) => items.map(mapItemWithSchema));
  }

  getListByMember(memberType: string) {
    return this.getList().then((requests) =>
      requests.filter(({ restricted_for }) => !restricted_for.includes(memberType))
    );
  }

  getById(id: number) {
    return this.methods
      .get<VacancyRequestLegacySchema>(`/account/vacancy_request/${id}`)
      .then(mapItemWithSchema);
  }
}
// TODO: переделать на именованный экспорт, в соответствии с README
export default new VacancyRequestLegacySchemaLayer(axiosApp);
